module.exports = __webpack_public_path__ + "static/media/arrow-bottom-icon.682aba96.svg";